import styled from "styled-components";
import Colors from "../../../../themes/Colors";

const AudienceImpactsHolder = styled.div`
  .screenCardAudit {
    border-radius: 8px;
    border: 1px solid ${Colors.primaryAccent};
    background-color: transparent;
    margin-bottom: 5px;
    margin-top: 5px;
    color: ${Colors.primaryAccent};
    margin: 5px auto;
    width: fit-content;
  }
`;

export default AudienceImpactsHolder;
